import {
    Box,
    FormControl,
    Grid,
    InputLabel,
    MenuItem,
    Typography
} from "@mui/material";

import {useState} from "react";

import {Controller, useForm} from "react-hook-form";
import {COUNTRIES, CountrySelectAutocomplete} from "@/components/Shared/CountrySelect";
import {Country} from "@/types/utils";
import {INDUSTRIES} from "@/utils/constants";
import {updateCustomer} from "@/services/customer";
import {useNotificationContext} from "@/contexts/NotificationContext";
import {UICardContent, UICardHeadingLight} from "@/components/Shared/Utils/UICard";
import Utils from "@/components/Shared/Utils";
import { grey } from "@mui/material/colors";

function resolveActiveCountry(label = "Vietnam") {
    return COUNTRIES?.find((country: Country) => country.label === label)
}

export default function ManageProfile({customer}: any) {
    const [isLoading, setLoading] = useState<boolean>(false)

    const [country, setCountry] = useState<Country>(() => resolveActiveCountry(customer?.customer_country?.label || "Vietnam") || COUNTRIES[0])
    const {notification, setNotification} = useNotificationContext()

    const {
        control,
        handleSubmit,
        formState: {
            isDirty
        }
    } = useForm({
        defaultValues: {
            ...customer,
            customer_country: country
        }
    });

    async function handleSubmitCustomer(data: any) {
        setLoading(true)

        const response = await updateCustomer(customer?.customer_id, {
            customer: data
        })

        if (response?.data?.customer) {
            setNotification({
                ...notification,
                message: `customer [${customer.customer_id}] information update success.`,
                severity: 'success',
                open: true
            })
        }

        setLoading(false)
    }

    // console.log(errors)

    return (
        <>
            <UICardHeadingLight title="Customer Profile"
                           description="Your key contact information for accessing our support and sales teams."/>
            <UICardContent>
                <Box p={2}>
                    {customer ? (
                        <Grid container>
                        <Grid item md={4} xs={12}>
                            <Box component="form">
                                <Box mb={2}>
                                    <Controller
                                        control={control}
                                        disabled
                                        name="customer_email"
                                        render={({field}) => (
                                            <Utils.FormUtils.PrimaryInput
                                                {...field}
                                                value={customer?.customer_email}
                                                label="Primary Email"
                                            />
                                        )}
                                    />
                                </Box>

                                <Box mb={2}>
                                    <Grid container>
                                        <Grid item md={4}>
                                            <Controller
                                                control={control}
                                                name="customer_country"
                                                render={({field: {onChange, ...field}}) => (
                                                    <CountrySelectAutocomplete
                                                        onChange={(country: Country) => {
                                                            setCountry(country);
                                                            onChange(country)
                                                        }} {...field} />
                                                )}
                                            />
                                        </Grid>
                                        <Grid item md={8}>
                                            <Controller
                                                control={control}
                                                name="customer_phone"
                                                render={({field}) => (
                                                    <Utils.FormUtils.PrimaryInput {...field}
                                                                                  label="Customer Phone (*)"/>
                                                )}/>
                                        </Grid>
                                    </Grid>
                                </Box>

                                <Box mb={2}>
                                    <Controller
                                        name="customer_business_field"
                                        control={control}
                                        render={({field}) => (
                                            <FormControl fullWidth>
                                                <InputLabel id="industry" sx={{fontSize: 16}} shrink>
                                                    Industry
                                                </InputLabel>
                                                <Utils.FormUtils.PrimarySelect {...field}>
                                                    {INDUSTRIES.map((item) => {
                                                        return (
                                                            <MenuItem value={item.value} key={item.value}>
                                                                <Typography fontSize={12}>
                                                                    {item.label}
                                                                </Typography>
                                                            </MenuItem>
                                                        )
                                                    })}
                                                </Utils.FormUtils.PrimarySelect>
                                            </FormControl>
                                        )}
                                    />
                                </Box>

                                <Box mb={2}>
                                    <Controller
                                        control={control}
                                        name="customer_website"
                                        render={({field}) => (
                                            <Utils.FormUtils.PrimaryInput {...field} label="Website"/>
                                        )}
                                    />
                                </Box>

                                <Utils.AsyncButton
                                    text="Update"
                                    disabled={isLoading || !isDirty}
                                    isLoading={isLoading}
                                    callback={handleSubmit(handleSubmitCustomer)}
                                />
                            </Box>
                        </Grid>
                    </Grid>
                    ): (
                        <Box>
                            <Typography fontSize={13} color={grey[700]}>
                            It appears there isn't a customer profile associated with this. For more information or to resolve this, please contact our support team.
                            </Typography>
                        </Box>
                    )}
                </Box>
            </UICardContent>
        </>
    )
}